import queryString from 'query-string';

import { AsyncAction } from '../../../services/apiMiddleware';
import { OkrLabel, OkrLabelAdd } from '../interfaces';
import { okrApi } from '../../../services/ApiController';

import { addLabelsActions, deleteLabelsActions, fetchLabelsActions } from './actionTypes';

export const fetchLabels = (
  name?: string,
  queryObj?: FetchLabelsParams,
  loadMore?: boolean,
): AsyncAction<OkrLabel[]> => {
  const queryParams = queryString.stringify(queryObj || {});
  return {
    types: fetchLabelsActions,
    // TODO: sort by name & proper support needed for search by name with multypage from BE!!!
    callAPI: () => okrApi.get(`${name ? `search/labels/${name}` : '/labels'}?${queryParams}`),
    payload: { loadMore },
  };
};

export const addLabel = (label: OkrLabelAdd): AsyncAction<OkrLabel> => ({
  types: addLabelsActions,
  callAPI: () => okrApi.post('labels', label),
});

// TODO REPLACE WITH RESPONSE
export const deleteLabel = (id: string): AsyncAction<null> => ({
  types: deleteLabelsActions,
  callAPI: () => okrApi.delete(`labels/${id}`),
  payload: { labelId: id },
});

export interface FetchLabelsParams {
  page?: number;
  sort: 'name' | '-name';
  search?: string | null;
  per_page?: number;
}
